// React 19 compatibility shim for legacy ReactDOM.render API
// This allows old libraries like react-tippy to work with React 19

import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';

// Only add the shim if render doesn't exist (React 19+)
if (!ReactDOM.render) {
    const rootsMap = new WeakMap();

    ReactDOM.render = (element, container, callback) => {
        let root = rootsMap.get(container);
        if (!root) {
            root = createRoot(container);
            rootsMap.set(container, root);
        }

        root.render(element);

        if (callback) callback();
    };

    ReactDOM.unmountComponentAtNode = function(container) {
        const root = rootsMap.get(container);
        if (root) {
            root.unmount();
            rootsMap.delete(container);
            return true;
        }

        return false;
    };
}

// Shim for ReactDOM.findDOMNode (removed in React 19)
// Used by legacy libraries like react-grid-layout and react-draggable
if (!ReactDOM.findDOMNode) {
    ReactDOM.findDOMNode = component => {
        // For React 19, we need to use refs instead
        // This is a fallback that returns the component itself if it's a DOM element
        if (component instanceof HTMLElement) {
            return component;
        }

        // If it's a React component instance, try to get the DOM node from it
        if (component && component._reactInternals && component._reactInternals.child) {
            const fiber = component._reactInternals.child;
            // Find the first DOM node in the fiber tree
            let node = fiber;
            while (node) {
                if (node.stateNode instanceof HTMLElement) {
                    return node.stateNode;
                }
                node = node.child;
            }
        }

        console.warn('ReactDOM.findDOMNode is deprecated. Please use refs instead.');
        return null;
    };
}

export default ReactDOM;
